<template>
  <div class="item" id="about2">
    <div class="item-content">
      <div class="left">
        <img :src="IMG1" />
        <div class="name">
          <div class="bold">公司资质</div>
          <div class="desc">COMPANY QUALIFICATION</div>
        </div>
      </div>
      <div class="right">
        <img :src="IMG2" />
        <img :src="IMG3" />
      </div>
    </div>
  </div>
</template>

<script>
import IMG1 from '../../assets/images/about/91.png'
import IMG2 from '../../assets/images/about/2.png'
import IMG3 from '../../assets/images/about/1.png'
export default {
  data () {
    return {
      IMG1,
      IMG2,
      IMG3
    }
  }
}
</script>

<style lang="less" scoped>
.item-content {
  width: 100%;
  display: flex;
  justify-content: center;

  .left {
    position: relative;
    img {
      width: 463px;
      height: 530px;
    }
    .name {
      position: absolute;
      top: 40px;
      right: -126px;
      background: rgba(255, 255, 255, .5);
      padding: 20px;
      .bold {
        font-weight: bolder;
        font-size: 48px;
      }

      .desc {
        color: #969696;
      }
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    margin-left: 200px;
    img {
      width: 581px;
    }
  }
}
</style>